import React from 'react';
import { SuccessStoryCard } from '../Components/SuccessStoryCard';

export default function Carousel({ settings, section, blocks }) {
  const { successStories } = settings;

  const slideWidth = section.visible_slide_width_mobile ?? 85;

  return (
    <div className="flex flex-col gap-8">
      <div className="text-center pr-3">
        {section.title && (
          <div className={`${section.title_font_type_mobile || section.title_font_type}`}>
            {section.title}
          </div>
        )}
      </div>

      <div
        className="success-stories-carousel carousel flickity-dot-relative"
        {...({
          "x-data": "carousel",
          "x-init": `$nextTick(() => { initialise(${section.show_indicators ?? true}, ${section.show_navbuttons ?? false}, ${section.fade_edgeitems ?? false}, false, 0, 'success-stories-carousel', true, ${section.use_freescroll ?? true}) })`,
          "x-ref": "carousel",
        })}
      >
        {successStories?.map((column, index) => {
          const block = blocks.find(b => b.id === column.block_id);
          return (
            <div
              key={block.id}
              style={{ width: `${slideWidth}%`, marginRight: `${section.gap ?? 4}px` }}
            >
              <SuccessStoryCard column={column} block={block} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
